var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisionBoard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5063 5.67271C20.542 9.63697 19.9639 17.6481 19.5509 20.5387L13.1001 20.9788C10.9201 21.1275 9.3965 23.2262 10.2511 25.2372C13.0194 31.7516 18.2401 36.9596 24.7552 39.7378C26.7684 40.5967 28.8732 39.0726 29.0222 36.889L29.4616 30.4493C32.3522 30.0363 40.3633 29.4582 44.3274 25.494C53.1836 16.6378 33.3625 -3.18353 24.5063 5.67271Z",
    stroke: "black",
    strokeWidth: 3.575,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0622 33.9383L3.44592 46.5545",
    stroke: "black",
    strokeWidth: 3.575,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisionBoard);
export default __webpack_public_path__ + "static/media/vision_board.11e13de3e872a3f7dd7deb5644c4cfcb.svg";
export { ForwardRef as ReactComponent };